import { ActivityIndicator, Pressable, StyleSheet, TouchableOpacity, View } from "react-native";
import React, { memo } from "react";
import Svg, { Path } from "react-native-svg";
import { fp, hp, spV, wp } from "utils/normalise";

import { Colors } from "colors";
import VText from "components/VText";

const StepperButton = ({
    onPressMinusBtn = () => {},
    onPressPlusBtn = () => {},
    itemCount = 0,
    customStyle = {},
    loading = false,
    isError = false,
    MAX_CART_QTY = 10,
    svgIconsSize = 25,
    countStyle = {},
    btnContainerstyle = {},
    disabled = false,
    
}) => {
    return (
        <View style={[Styles.container, customStyle, { borderColor: isError ? "#CE1A1A" : Colors.black, opacity: disabled ? 0.3 : 1 }]}>
            <TouchableOpacity
                disabled={disabled}
                style={[
                    Styles.btnContainer,
                    {
                        opacity: itemCount == 0 ? 0.6 : 1,
                    },
                    btnContainerstyle,
                ]}
                onPress={() => {
                    if (!loading) onPressMinusBtn();
                }}
            >
                <Svg
                    width={svgIconsSize}
                    height={svgIconsSize}
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <Path d="M20.5 12L4.5 12" stroke={isError ? "#CE1A1A" : "#212427"} strokeWidth="2" />
                </Svg>
            </TouchableOpacity>
            <View
                style={{
                    paddingHorizontal: 6,
                }}
            >
                {!loading && (
                    <VText
                        style={[
                            {
                                color: isError ? "#CE1A1A" : Colors.black,
                                fontSize: fp(18),
                                fontWeight: "550",
                                lineHeight: fp(18),
                            },
                            countStyle,
                        ]}
                    >
                        {itemCount}
                    </VText>
                )}
                {loading && <ActivityIndicator />}
            </View>
            <TouchableOpacity
                disabled={disabled}
                style={[Styles.btnContainer, { opacity: itemCount == MAX_CART_QTY ? 0.6 : 1 }, btnContainerstyle]}
                onPress={() => {
                    if (!loading) onPressPlusBtn();
                }}
            >
                <Svg
                    width={svgIconsSize}
                    height={svgIconsSize}
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <Path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.5 13V20H13.5V13H20.5V11H13.5V4H11.5V11H4.5V13H11.5Z"
                        fill={isError ? "#CE1A1A" : "#212427"}
                    />
                </Svg>
            </TouchableOpacity>
        </View>
    );
};

export default memo(StepperButton);

const Styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        borderWidth: 1,
        backgroundColor: Colors.white,
        justifyContent: "space-evenly",
        alignItems: "center",
        minWidth: wp(80),
        height: hp(44),
    },
    btnContainer: {
        paddingHorizontal: 8,
        minWidth: 24,
    },
});
